import trackItemChanges from '../helpers/trackItemChanges'
import loadTraits from '../helpers/loadTraits'

import processTagContainers from './processTagContainters.js'
//---------------------
// process delete item
//---------------------
export default function processDeleteItem({
  item,
  character,
  changed_items = [],
  original_items = [],
  delete_payload = null,
}) {
  console.log('--------------------------------')
  console.log('IN processDeleteItem item = ', item)
  let calc_containers = []
  //-----------------------------------------
  // build new array excluding deletion item
  //-----------------------------------------
  const newItems = character.items.filter((s) => s.id !== item.id)
  //------------------
  // assign new array
  //------------------
  character.items = newItems
  character = loadTraits({ character })
  //---------------------------------
  // track changes (record deletion)
  //---------------------------------
  const updated_changed_items = trackItemChanges({
    item,
    original_items: original_items,
    changed_items: changed_items,
    delete_payload,
    delete: true, // used to remove entry from changed_items where is new local item (not written to db yet)
  })
  console.log('updated_changed_items after deletion:', updated_changed_items)
  //-----------------------------
  // check item was in container
  //-----------------------------
  if (item.container) {
    console.log('deleted item was in container id = ', item.container)
    console.log('need to recalc container contents for container id = ', item.container)
    //-------------------------------------------------------
    // go process tag containers (for calcs in main process)
    //-------------------------------------------------------
    calc_containers = processTagContainers({
      container_id: item.container,
      character_items: character.items,
    })
  } else {
    console.log('deleted item was not in a container - no need to recalc container contents')
  }
  //---------
  // returns
  //---------
  return { character, updated_changed_items, calc_containers }
}
